export default {
	messages: {
		de: {
			defaultValues: 'Standard-Werte',
		},
		en: {
			defaultValues: 'Default Values',
		},
	},
};
